module.exports = __webpack_public_path__ + "static/media/wallet_white.4f6bf0d8.svg";